import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.producer,
    routes: [
        {
            path: '/merchandise',
            component: FuseLoadable({
                loader: () => import('./MerchandiseApp'),
            }),
        },
        {
            path: '/merchandise-purchases',
            component: FuseLoadable({
                loader: () => import('./MerchandisePurchasesProducer'),
            }),
        },
    ],
};

export default [Index];
